/**
 * 支付管理 支付配置
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营日志</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="车辆编号:">
        <el-input size="small" v-model="formInline.vin" placeholder="输入车辆编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="负责组">
        <el-select size="small" v-model="formInline.groupId" clearable filterable @click="groupList()"
          placeholder="输入小组名称">
          <el-option v-for="item in groupName" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆状态">
        <el-select size="small" v-model="formInline.carStatus" clearable filterable @click="onClick()"
          placeholder="请选择车辆状态">
          <el-option v-for="item in carStatus" :key="item.id" :label="item.dict_value" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地点">
        <el-cascader v-model="carPlace" size="small" style="width: 100%" :options="carAddress" :show-all-levels="false"
          :props="{ checkStrictly: true }" clearable></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleAdd()"
          v-if="check_auth('/web/operatingLog/add')">添加日志</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="handleExport()" v-if="check_auth('/web/operatingLog/export')">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%">
      <el-table-column align="center" header-align="center" prop="id" label="编号" width="80"></el-table-column>
      <el-table-column prop="vin" label="车辆编号" min-width="150" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="carType" label="车辆型号" min-width="120" header-align="center" align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="groupName" label="负责组" min-width="100" header-align="center" align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="fault" label="车辆故障状态" min-width="150" header-align="center" align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="carStatusName" label="车辆状态" header-align="center" align="center" min-width="120"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="carSpecificExpression" label="车辆异常具体表现" min-width="150" align="center" header-align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="faultRate" label="故障率" min-width="120" align="center" header-align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="placeNowName" label="现属地点" align="center" header-align="center" min-width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="carRoute" label="车辆行驶线路" min-width="150" align="center" header-align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="equipMan" label="人员配备" min-width="120" align="center" header-align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="selectDate" label="日期" min-width="300" align="center" header-align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200" align="center" header-align="center"
        v-if="check_auth('/web/operatingLog/deleteOperatingLog')">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button> -->
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)"
            v-if="check_auth('/web/operatingLog/deleteOperatingLog')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加界面 -->
    <el-dialog title="添加" :visible.sync="addFormVisible" width="35%" @close="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form class="demo-form-inline" label-width="17%" :model="addForm" ref="addForm" :rules="rules">
        <el-form-item label="车辆编号" prop="vin">
          <el-select size="small" style="width: 100%" v-model="addForm.vin" clearable filterable @click="addCarList()"
            placeholder="请选择车辆编号">
            <el-option v-for="item in addCarVin" :key="item.id" :label="item.vin" :value="item.vin">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="groupId" label="负责小组">
          <el-select size="small" style="width: 100%" v-model="addForm.groupId" clearable filterable
            @click="addGroupList()" placeholder="请选择负责小组">
            <el-option v-for="item in groupNameAdd" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆状态" prop="carStatus">
          <el-select size="small" style="width: 100%" v-model="addForm.carStatus" clearable filterable @click="addClick()"
            placeholder="请选择车辆状态">
            <el-option v-for="items in carAdd_status" :key="items.id" :label="items.dict_value" :value="items.id">
              <div @mousemove="mouseOver(items)" @mouseleave="mouseLeave(items)">
                <span>{{ items.dict_value
                }}</span>
                <span v-if="items.show" style="float: right; color: #8492a6; font-size: 13px">{{ items.remark }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="异常具体表现" prop="carSpecificExpression">
          <el-input size="small" v-model="addForm.carSpecificExpression" auto-complete="off" clearable
            placeholder="请输入车辆异常具体表现">
          </el-input>
        </el-form-item>
        <el-form-item label="故障率(%)" prop="faultRate">
          <el-input size="small" v-model="addForm.faultRate" auto-complete="off" clearable
            placeholder="请输入故障率"></el-input>
        </el-form-item>
        <el-form-item label="现属地点" prop="addPlaceNowId">
          <el-cascader v-model="addForm.addPlaceNowId" size="small" style="width: 100%" :options="nowAddress"
            :show-all-levels="false" :props="{ checkStrictly: true }" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="车辆行驶路线" prop="carRoute">
          <el-input size="small" v-model="addForm.carRoute" auto-complete="off" clearable
            placeholder="请输入车辆行驶路线"></el-input>
        </el-form-item>
        <el-form-item label="人员配备" prop="equipMan">
          <el-input size="small" v-model="addForm.equipMan" auto-complete="off" clearable
            placeholder="请输入人员姓名"></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="selectDate">
          <div class="block">
            <el-date-picker v-model="addForm.selectDate" size="small" style="width: 100%" clearable
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormAdd('addForm')">确 定</el-button>
        <el-button @click="closeDialog('addForm')">取 消</el-button>
      </div>
  </el-dialog>
  <!-- 编辑界面 -->
  <!-- <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @close="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        class="demo-form-inline"
        label-width="
        110px"
        :model="editForm"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="车辆编号" prop="vin">
          <el-select
            style="width: 410px"
            size="small"
            v-model="editForm.vin"
            clearable
            filterable
            @click="editCarList()"
            placeholder="请选择车辆编号"
          >
            <el-option
              v-for="item in editCarVin"
              :key="item.id"
              :label="item.vin"
              :value="item.vin"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="groupId" label="负责小组">
          <el-select
            size="small"
            style="width: 410px"
            v-model="editForm.groupId"
            clearable
            filterable
            @click="editGroupList()"
            placeholder="请选择负责小组"
          >
            <el-option
              v-for="item in groupNameEdit"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆状态" prop="carStatus">
          <el-select
            size="small"
            style="width: 410px"
            v-model="editForm.carStatus"
            clearable
            filterable
            @click="editClick()"
            placeholder="请选择车辆状态"
          >
            <el-option
              v-for="item in carEdit_status"
              :key="item.id"
              :label="item.dict_value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="异常具体表现" prop="carDistanceExpression">
          <el-input
            size="small"
            v-model="editForm.carDistanceExpression"
            auto-complete="off"
            placeholder="请输入车辆异常具体表现"
          ></el-input>
        </el-form-item>
        <el-form-item label="故障率" prop="faultRate">
          <el-input
            size="small"
            v-model="editForm.faultRate"
            auto-complete="off"
            placeholder="请输入故障率"
          ></el-input>
        </el-form-item>
        <el-form-item label="现属地点" prop="placeNowId">
          <el-select
            size="small"
            style="width: 410px"
            v-model="editForm.placeNowId"
            clearable
            filterable
            @change="editAddressList()"
            placeholder="请选择地点"
          >
            <el-option
              v-for="item in editAddress"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆行驶路线" prop="carRoute">
          <el-input
            size="small"
            v-model="editForm.carRoute"
            auto-complete="off"
            placeholder="请输入车辆行驶路线"
          ></el-input>
        </el-form-item>
        <el-form-item label="人员配备" prop="equipMan">
          <el-input
            size="small"
            v-model="editForm.equipMan"
            auto-complete="off"
            placeholder="请输入人员姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="selectDate">
          <div class="block">
            <el-date-picker
              v-model="editForm.selectDate"
              size="small"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
       <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormEdit('editForm')"
          >确 定</el-button
        >
                    <el-button @click="closeDialog('editForm')">取 消</el-button>
                  </div>
                </el-dialog> -->
  </div>
</template>

<script>
import {
  get_queryList_list,
  get_queryGroup_list,
  get_queryCarStatus_list,
  get_queryPlace_list,
  get_querySelectableCar_list,
  get_operate_add,
  get_operate_export,
  get_operate_del,
} from "../../api/car_operate/car_operate";
import { auth } from "../../utils/util";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      transformVal: 0,
      loading: false, //是显示加载
      // editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      title: "添加",
      driver_open: true,
      carStatus: [],
      groupName: [],
      carAddress: [],
      carPlace: [],
      //添加的下拉列表
      addCarVin: [],
      groupNameAdd: [],
      carAdd_status: [],
      nowAddress: [],
      // addPlaceNowId:[],
      // 编辑的下拉列表
      // editCarVin: [],
      // groupNameEdit: [],
      // carEdit_status: [],
      // editAddress: [],
      addForm: {
        id: "",
        vin: "",
        groupId: "",
        carStatus: "",
        carSpecificExpression: "",
        faultRate: "",
        placeNowId: "",
        addPlaceNowId: [],
        carRoute: "",
        equipMan: "",
        selectDate: "",
      },
      //编辑
      // editForm: {
      //   id: "",
      //   vin: "",
      //   groupId:"",
      //   carStatus:"",
      //   carDistanceExpression: "",
      //   faultRate: "",
      //   placeNowId: '',
      //   carRoute: "",
      //   equipMan: "",
      //   selectDate: "",
      // },

      // rules表单验证
      rules: {
        vin: [{ required: true, message: "请选择车辆编号", trigger: "change" }],
        groupId: [
          { required: true, message: "请选择向负责小组", trigger: "change" },
        ],
        carStatus: [
          { required: true, message: "请选择车辆状态", trigger: "change" },
        ],
        carSpecificExpression: [
          {
            required: true,
            message: "请输入车辆异常具体表现",
            trigger: "blur",
          },
        ],
        faultRate: [
          { required: true, message: "请输入故障率", trigger: "change" },
          {
            pattern: /^\d+$|^\d+[.]?\d+$/,
            message: "请输入数字,如48",
            trigger: "change",
          },
        ],
        addPlaceNowId: [
          { required: true, message: "请选择现属地点", trigger: "change" },
        ],
        carRoute: [
          { required: true, message: "请输入行驶路线", trigger: "blur" },
        ],
        equipMan: [
          { required: true, message: "请输入人员配备", trigger: "blur" },
        ],
        selectDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
      formInline: {
        vin: "",
        groupId: "",
        carStatus: "",
        carAddress: "",
        page: 1,
        limit: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
    this.groupList();
    this.onClick();
    this.addressList();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    check_auth(val) {
      return auth(val);
    },
    mouseOver(row) {
      this.$set(row, 'show', true);
    },
    // 移出
    mouseLeave(row) {
      this.$set(row, 'show', false);
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    // 获取车辆列表
    getData() {
      get_queryList_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          for (let i = 0; i < this.listData.length; i++) {
            this.listData[i].faultRate = this.listData[i].faultRate + "%";
            let time = this.listData[i].selectDate;
            this.listData[i].selectDate = this.timestampToTime(time * 1000);
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["count"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.carAddress = "";
      for (let i = 0; i < this.carPlace.length; i++) {
        this.formInline.carAddress = this.carPlace[this.carPlace.length - 1];
      }
      this.formInline.page = 1;
      this.getData();
    },
    //选择负责小组
    groupList() {
      get_queryGroup_list().then((res) => {
        if (res["code"] === 0) {
          this.groupName = res.data;
        }
      });
    },
    //选择车辆状态
    onClick() {
      get_queryCarStatus_list().then((res) => {
        if (res["code"] === 0) {
          this.carStatus = res.data;
        }
      });
    },
    //选择地点
    addressList() {
      get_queryPlace_list().then((res) => {
        if (res["code"] === 0) {
          this.carAddress = res.data;
        }
      });
    },
    // 添加中 车辆下拉列表
    addCarList() {
      get_querySelectableCar_list().then((res) => {
        if (res["code"] === 0) {
          this.addCarVin = res.data;
        }
      });
    },
    //添加中 选择负责小组
    addGroupList() {
      get_queryGroup_list().then((res) => {
        if (res["code"] === 0) {
          this.groupNameAdd = res.data;
        }
      });
    },
    //添加中 选择车辆状态
    addClick() {
      get_queryCarStatus_list().then((res) => {
        if (res["code"] === 0) {
          this.carAdd_status = res.data;
        }
      });
    },
    //添加中 选择地点
    onAddressList() {
      get_queryPlace_list().then((res) => {
        if (res["code"] === 0) {
          this.nowAddress = res.data;
        }
      });
    },
    //添加数据
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
      this.addCarList();
      this.addGroupList();
      this.addClick();
      this.onAddressList();
    },
    submitFormAdd(addData) {
      this.addForm.placeNowId =
        this.addForm.addPlaceNowId == undefined
          ? ""
          : this.addForm.addPlaceNowId[this.addForm.addPlaceNowId.length - 1];
      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_operate_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.addFormVisible = false;
              this.addForm = {};
              this.getData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑中 车辆下拉列表
    // editCarList() {
    //   get_querySelectableCar_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.editCarVin = res.data;
    //     }
    //   });
    // },
    // //编辑中 选择负责小组
    // editGroupList() {
    //   get_queryGroup_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.groupNameEdit = res.data;
    //     }
    //   });
    // },
    // //编辑中 选择车辆状态
    // editClick() {
    //   get_queryCarStatus_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.carEdit_status = res.data;
    //     }
    //   });
    // },
    // //编辑中 选择地点
    // editAddressList() {
    //   get_queryPlace_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.editAddress = res.data;
    //     }
    //   });
    // },
    // //显示编辑界面
    // handleEdit(row) {
    //   this.title = "修改";
    //   this.editCarList();
    //   this.editGroupList();
    //   this.editClick();
    //   this.editAddressList();
    //   get_operate_id(row.id).then((res) => {
    //     if (res["code"] === 0) {
    //       this.editForm = res.data;
    //       this.editForm.placeNowId = Number(this.editForm.placeNowId);
    //       this.editForm.selectDate = this.timestampToTime(
    //         this.editForm.selectDate * 1000
    //       );
    //       this.editFormVisible = true;
    //     }
    //   });
    // },
    // // 编辑页面保存方法
    // submitFormEdit(editData) {
    //   this.$refs[editData].validate((valid) => {
    //     if (valid) {
    //       get_operate_edit(this.editForm).then((res) => {
    //         if (res["code"] === 0) {
    //           this.editFormVisible = false;
    //           this.getData();
    //           this.$message.success(res["message"]);
    //         }
    //       });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // 删除
    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
          get_operate_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleExport() {
      get_operate_export(this.formInline).then((res) => {
        if (res["code"] == undefined) {
          // 这里根据后端返回使用res或res.data
          var blob = new Blob([res], {
            type: "application/ms-excel",
          });
          var elink = document.createElement("a");
          elink.download = "运营日志" + ".xlsx";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click(); //点击下载
          URL.revokeObjectURL(elink); //释放掉blob对象
          document.body.removeChild(elink); //下载完成移除元素
        }
      })
        .catch((err) => {
          this.$notify.error({
            title: "提示",
            message: err.message,
          });
        });
    },
    handleSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callcar();
    },
    handleCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callcar();
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.addFormVisible = false;
    },
  },
};
</script>

<style lang=css scoped>
.user-search {
  margin-top: 20px;
  height: 60px !important;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/projectLog/operationLog_mn.vue